import { render } from "./NotificationBlock.vue?vue&type=template&id=7d736444&scoped=true"
import script from "./NotificationBlock.vue?vue&type=script&lang=js"
export * from "./NotificationBlock.vue?vue&type=script&lang=js"

import "./NotificationBlock.vue?vue&type=style&index=0&id=7d736444&lang=scss&scoped=true"

import exportComponent from "C:\\inetpub\\wwwroot\\areaclienti.luceegasitalia.it\\areaclienti\\areaclienti\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d736444"]])

export default __exports__